import { postRequest } from '@/utils/data-fetching/config.ts'

export interface GoogleMapsResult {
  address_components: {
    long_name: string
    short_name: string
    types: string[]
  }[]
  formatted_address: string
  geometry: {
    viewport: {
      northeast: {
        lat: number
        lng: number
      }
      southwest: {
        lat: number
        lng: number
      }
    }
    location: {
      lat: number
      lng: number
    }
  }
  place_id: string
  types: string[]
}

export interface GoogleMapsResponse {
  results: GoogleMapsResult[]
  status: string
}

export interface AutocompleteOption {
  label: string
  value: string
  isUsAddress?: boolean
  formattedAddress?: string
  placeId?: string
  country?: string
  adminAreaLevel1?: string
  adminAreaLevel2?: string
}

export const separatorString = ' $#$#$# '

export async function resolveLocation(
  value: string,
  callback: (options?: AutocompleteOption) => void,
) {
  if (!value) {
    return
  }
  const { data } = await postRequest<string>('/provider/googlemaps', {
    address: value,
    // eslint-disable-next-line camelcase
    api_request_type: 'geocode',
  })
  const { results } = JSON.parse(atob(data)) as GoogleMapsResponse
  if (results.length === 0) {
    callback()
    return
  }
  const result = results[0]

  const formattedAddress = result.formatted_address
  const placeId = result.place_id
  const country = result.address_components.find((component) =>
    component.types.includes('country'),
  )?.short_name
  const adminAreaLevel1 = result.address_components.find((component) =>
    component.types.includes('administrative_area_level_1'),
  )?.short_name
  const adminAreaLevel2 = result.address_components.find((component) =>
    component.types.includes('administrative_area_level_2'),
  )?.short_name

  const formattedOption = {
    label: result.formatted_address,
    value: [
      formattedAddress,
      placeId,
      country,
      adminAreaLevel1,
      adminAreaLevel2,
    ].join(separatorString),
    isUsAddress: country === 'United States',
    formattedAddress,
    placeId,
    country,
    adminAreaLevel1,
    adminAreaLevel2,
  }

  callback(formattedOption)
}
